import React, { useRef } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import type { Reel } from '../data/reels';
interface ReelPlayerProps {
  reel: Reel;
  featured?: boolean;
}
export function ReelPlayer({
  reel,
  featured = false
}: ReelPlayerProps) {
  const {
    language
  } = useLanguage();
  const containerRef = useRef<HTMLDivElement>(null);
  const isNearViewport = useInView(containerRef, {
    margin: '300px 0px 300px 0px'
  });
  const reduceMotion = useReducedMotion();
  const shouldPlay = isNearViewport && !reduceMotion;
  return <div ref={containerRef} className={`relative shrink-0 snap-center overflow-hidden bg-ink ${featured ? 'aspect-video w-[88vw] md:w-full' : 'aspect-[9/16] w-[76vw] md:w-full'}`} data-id="element-180" data-mp="3lpz57aq3vnh5">
      <img src={reel.poster} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-181" data-mp="2t1uwegc8mua8" />
      {shouldPlay ? <iframe src={`https://www.youtube-nocookie.com/embed/${reel.id}?autoplay=1&mute=1&loop=1&playlist=${reel.id}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3&disablekb=1&fs=0`} title={reel.title[language]} allow="autoplay; encrypted-media" className={`pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border-0 ${reel.format === 'vertical' ? 'h-full w-full' : 'h-[56.25vw] min-h-full w-[177.78vh] min-w-full'}`} data-id="element-182" data-mp="2xzdb6ncxs3q5" /> : null}
      <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-ivory/10" data-id="element-183" data-mp="3fmqa5fh1x2kp" />
    </div>;
}